import { LARGE, LIGHT } from "../core-modules/constants";

import Box from "./Box";
import HeaderBackgroundImage from "./HeaderBackgroundImage";
import HeadingMain from "./HeadingMain";
import Nav from "./Nav";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";
import { useBrand } from "./BrandContext";
import { useTakebackConfig } from "./TakebackConfigContext";

function HeaderCopy({ size, mainHeading, subheading }) {
  const { headerTextTheme } = useTakebackConfig();
  const textColor = headerTextTheme === LIGHT ? "background" : "foreground";

  return (
    <Box
      position="relative"
      zIndex={1}
      maxWidth={1280}
      width="100%"
      mx="auto"
      flex="1"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      pt={[40, null, 60, null]}
      pb={[40, null, 80, null]}
    >
      <Box px={[null, null, null, "7.75vw"]}>
        <Text
          as="h1"
          fontSize={
            size === LARGE ? [42, null, null, 82] : [32, null, null, 42]
          }
          lineHeight={1}
          color={textColor}
          uppercase
          fontWeight={700}
          fontFamily="bold"
        >
          {mainHeading}
        </Text>
        {subheading && (
          <HeadingMain
            mt={30}
            uppercase={false}
            color={textColor}
            lineHeight={1.25}
          >
            {subheading}
          </HeadingMain>
        )}
      </Box>
    </Box>
  );
}

function Header({ mainHeading, subheading, size }) {
  const { live, holdingPageHeading } = useBrand();
  const { headerImageUrls, headerBackgroundColour } = useTakebackConfig();

  return (
    <Box
      minHeight={
        size === LARGE ? [400, null, 590, null] : [225, null, 280, null]
      }
      backgroundColor={headerBackgroundColour}
      position="relative"
      px="4vw"
      display="flex"
      flexDirection="column"
    >
      <Nav />
      <HeaderCopy
        size={size}
        mainHeading={live ? mainHeading : holdingPageHeading}
        subheading={live ? subheading : null}
      />
      {headerImageUrls && size === LARGE && <HeaderBackgroundImage />}
    </Box>
  );
}

Header.propTypes = {
  mainHeading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  size: PropTypes.string.isRequired,
};

export default Header;
